<script>
    import {createEventDispatcher} from 'svelte/internal';
    // import Icon from "../components/Icon.svelte";

    export let disabled = false;
    export let topRight = false;

    const dispatch = createEventDispatcher();

    const onClick = () => {
        if (!disabled) {
            dispatch('click');
        }
    };
</script>

<div class="close-button" class:display-absolute={ topRight } on:click="{ onClick }" class:disabled={ disabled }>
<!--    <Icon name="x" size="18" strokeWidth="2"/>-->
    &times;
</div>

<style>
    .close-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        color: #d2d2d2;
        font-size: 1.7rem;
        font-weight: 100;
        line-height: 1;
        margin-top: -10px;
        cursor: pointer;
    }

    .close-button:hover {
        color: #bcbcbc;
    }

    .close-button.disabled {
        color: #e5e5e5;
    }

    .display-absolute {
        position: absolute;
        top:15px;
        right:15px;
    }
</style>